import Repository from '../axios'

const resource = "/admin";

export default {
  uploadBase64File(payload) {
    return Repository.post(`${resource}/file-upload-b64`, payload)
  },
  uploadFileWithPath(form_data){
    return Repository.post(`${resource}/file-upload`, form_data, {headers: {
      'Content-Type': 'multipart/form-data'
    }})
  }
};
